'use client';

import React from "react";
import Image from 'next/image';

// Assets
import ISuccess from "@public/png/mailbox.png"

// Components
import Modal from '@src/components/atoms/modal'

const ModalSuccess = ({ onClose, ...props }) => {
  return (
    <Modal {...props} onClose={onClose} className="!items-start">
      <div className='max-w-[360px] flex flex-col items-center mt-[56px] z-[42] w-full mx-4 rounded-[16px] bg-[#FAFAFA] p-4'>
        <Image src={ISuccess} alt="success" width={144} height={144} className="aspect-square mb-2" />
        <p className="text-[21px]/[25.2px] font-satoshi-bold mb-2 text-center">Data Berhasil Dikirim</p>
        <p className="text-[14px]/[19.6px] font-satoshi mb-4 text-center">Kamu akan segera diarahkan ke WhatsApp untuk mulai ngobrol dengan marketing properti.</p>
        <button onClick={onClose} className="flex w-fit items-center gap-1 w-fit rounded-[8px] py-2 px-[12px] bg-[#FFC72C] text-[17px]/[23.8px] font-sfpro-bold tracking-[-0.17px]" type="button">Tutup</button>
      </div>
    </Modal>
  )
}

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null
  return <ModalSuccess isOpen={isOpen} {...props} />
}

export default Wrapper